import { SYNTHETIC_DATA_DEMO_PDF } from './syntheticDataDemoContent.part01.js'
import {
  SYNTHETIC_DATA_DEMO_ARTIFACT_ID,
  buildSyntheticDataDemoArtifactPreview,
} from './syntheticDataDemoArtifact.js'

/**
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').DocumentPreviewSelection} selection
 */
export function isSyntheticDataDemoArtifact(selection) {
  const name = String(selection?.fileName ?? '')
  return (
    selection?.artifactId === SYNTHETIC_DATA_DEMO_ARTIFACT_ID ||
    name.includes('An_overview_of_large_AI_models') ||
    name.includes('An_over...licati')
  )
}

/**
 * @param {string | undefined} artifactId
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').DocumentPreviewSelection} selection
 */
export function buildSyntheticDataDemoArtifact(artifactId, selection) {
  const artifact = buildSyntheticDataDemoArtifactPreview()
  return {
    ...artifact,
    artifactId: artifactId || SYNTHETIC_DATA_DEMO_ARTIFACT_ID,
    fileName: selection?.fileName ?? SYNTHETIC_DATA_DEMO_PDF,
    description: selection?.description ?? artifact.description,
  }
}
